angular.module('elogbooksServices').service('bulkReassignJobOperativesModal', ['apiClient', '$uibModal', function (apiClient, $uibModal) {
    return {
        open: function (jobs, rootResourceResponse, userResponse, selectedSiteResponse, jobsCount, selectedSP, config, selected) {
            return $uibModal.open({
                templateUrl: '/modules/common/modals/bulk-update/bulkaction-modal.html',
                controller: 'BulkActionCreateController',
                controllerAs: 'vm',
                resolve: {
                    config: function () {
                        var defaultConfig = {
                            titleMessage: 'REASSIGN_OPERATIVE',
                            bodyMessage: 'ARE_YOU_SURE',
                            updateMessage: 'JOBS_QUEUED_FOR_REASSIGNMENT',
                            selected: selected,
                            bulkAsssigntype: 'reassign-operatives'
                        };
                        return angular.extend({}, defaultConfig, config);
                    },
                    serviceProviderResponse: function(apiClient) {
                        var serviceProviderLink = (selectedSiteResponse === null) ?
                            userResponse.getLink('serviceproviders') : selectedSiteResponse.getLink('serviceproviders');

                        return apiClient.get(serviceProviderLink).then(function(response) {
                            return response;
                        });
                    },
                    jobs: function() {
                        return jobs;
                    },
                    jobsCount: function() {
                        return jobsCount;
                    },
                    selectedSite: function() {
                        return selectedSiteResponse;
                    },
                    selectedSP: function() {
                        return selectedSP;
                    },
                    rootResourceResponse: function() {
                        return rootResourceResponse;
                    },
                    user: function() {
                        return userResponse;
                    },
                    canBulkReassignOperative: function() {
                        return null;
                    }
                }
            });
        }
    };
}]);
